import React from 'react';
import { getGroupedScaleChords } from '../utils/chordsHelpers';
import { logChordStepperUsage } from '../config/firebase';

interface ChordStepperProps {
  selectedKey: string;
  scale: string;
  selectedChord: string;
  setSelectedChord: (chord: string) => void;
  showNumerals?: boolean;
  vertical?: boolean;
  closeModal?: () => void;
  instrumentName: string;
}

const ChordStepper: React.FC<ChordStepperProps> = ({ 
  selectedKey, 
  scale, 
  selectedChord, 
  setSelectedChord, 
  vertical, 
  showNumerals, 
  closeModal,
  instrumentName 
}) => {
  const groupedScaleChords = getGroupedScaleChords(`${selectedKey} ${scale}`);

  const handleChordToggle = (chord: string, stepNumber: number) => {
    if (selectedChord === chord) {
      setSelectedChord('');
    } else {
      setSelectedChord(chord);
      logChordStepperUsage(
        instrumentName,
        selectedKey,
        scale,
        chord,
        stepNumber + 1,
        groupedScaleChords.length
      );
    }
    if (closeModal) {
      closeModal();
    }
  };

  return (
    <div className=''>
      <ul className={`bg-base-200 steps steps-${vertical ? "vertical" : "horizontal"} w-full pb-4`}>
        {groupedScaleChords.map((chordGroup, groupIndex) => (
          <li 
            key={groupIndex} 
            className={`step cursor-pointer text-xs ${selectedChord === chordGroup[0].name ? 'step-accent' : ''} !min-w-0`}
            data-content={chordGroup[0].name}
            onClick={() => handleChordToggle(chordGroup[0].name, groupIndex)}
          >
            {showNumerals ? <span className='text-[0.65rem]'>{chordGroup[0].numeral}</span> : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChordStepper;